module.exports = __webpack_public_path__ + "img/header_img3.316bcb0b.png";